import {
    CLEAR_OLD_BALANCE,
    FETCH_OLD_BALANCE,
    LIST_OLD_BALANCE,
    LOADING_OLD_BALANCE,
    MODIFIED_OLD_BALANCE
} from "./types";

const init = {
    isLoading: false,
    data: {
        items: [],
        isEditable: true
    },
    filter: {}
};

export default (state = init, {type, payload}) => {
    switch (type) {
        case FETCH_OLD_BALANCE:
            return {
                ...state,
                filter: payload,
                isLoading: true
            };
        case LIST_OLD_BALANCE:
            return {
                ...state,
                isLoading: false,
                data: payload.data,
            };
        case CLEAR_OLD_BALANCE:
            return {
                isLoading: false,
                data: []
            };
        case MODIFIED_OLD_BALANCE:
            return {
                ...state,
                isLoading: true
            };
        case LOADING_OLD_BALANCE:
            return {
                ...state,
                isLoading: false
            };
        default:
            return state;
    }
}